// src/components/veradigm/VeradigmConnectButton.jsx
import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { apiService } from '@/services/api';
import { useUser } from '@/contexts/UserContext';
import { useVeradigmStore } from '@/stores/veradigmStore';

export function VeradigmConnectButton() {
  const { user } = useUser();
  const { setLoading, setError } = useVeradigmStore();
  const [isInitiating, setIsInitiating] = useState(false);
  
  const handleConnect = async () => {
    if (!user?.id) {
      console.error('VeradigmConnectButton: User ID not available');
      setError('User information not available. Please refresh and try again.');
      return;
    }
    
    setIsInitiating(true);
    setError(null);
    
    try {
      const response = await apiService.initiateVeradigmAuth(user.id);
      
      if (response.success && response.auth_url) {
        // Store the state in sessionStorage for verification during callback
        sessionStorage.setItem('veradigm_auth_state', response.state);
        // Redirect to Veradigm authentication URL
        window.location.href = response.auth_url;
      } else {
        console.error('VeradigmConnectButton: Invalid response', response);
        setError('Failed to initialize Veradigm authentication');
      }
    } catch (error) {
      console.error('VeradigmConnectButton: Error:', error);
      setError('Error connecting to Veradigm: ' + (error.message || 'Unknown error'));
    } finally {
      setIsInitiating(false);
    }
  };
  
  return (
    <Button 
      onClick={handleConnect} 
      disabled={isInitiating}
    >
      {isInitiating ? 'Connecting...' : 'Connect to Veradigm EHR'}
    </Button>
  );
}